// extracted by mini-css-extract-plugin
export default {"container":"Gk-z","blurb":"Hk-z","links":"Ik-z"};